module.exports = __webpack_public_path__ + "img/pdgt_mch.933a187c.jpg";